export const DETALHES_DESTINO = [
    {
        id: 5966,
        titulo: 'Caldas Novas',
        slug: 'caldas-novas',
        estado: 'Goiás',
        pais: 'Brasil',
        totalHoteis: 21,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop01.jpg',
        alt: 'Montreal Viagens - Caldas Novas',
        resumo: '' +
            'Caldas Novas é um destino que reúne conforto, lazer e experiências de aventura ideais — tanto' +
            ' se você gostar do contato com a natureza quanto se preferir paisagens urbanas. Localizada no' +
            ' sul de Goiás, próxima à Brasília e à Goiânia, a cidade também oferece programas que fogem do' +
            ' óbvio, capazes de transformar suas férias em pura diversão.',
        descricao: '' +
            'Pertinho de Brasília, a aproximadamente 400km, está uma das maiores estâncias hidrotermais' +
            ' do mundo: <strong>Caldas Novas,</strong> que atrai seus visitantes com as convidativas' +
            ' águas quentes, normalmente entre 30 e 57 graus.' +
            '<br><br>' +
            'Atualmente um dos mais importantes polos turísticos do estado de Goiás, o balneário reúne' +
            ' uma infraestrutura hoteleira impressionante, com atrações para todos os gostos, como o resort' +
            ' <strong>Acqua Park L’acqua diRoma,</strong> que possui um parque aquático com mais de 16.000m² com' +
            ' piscina de ondas, escorregador, toboáguas, duchas, ofurô, brinquedoteca, bares molhados e' +
            ' ainda cinema, academia, espaço gourmet e salão de jogos. ' +
            '<br><br>' +
            ' Bem perto do hotel está o <strong> Monumento das Águas</strong>,' +
            ' uma homenagem ao maior bem da cidade, que vale um tempinho para fotos.' +
            '<br><br>' +
            'Porém, Caldas Novas é muito mais que suas famosas águas quentes. Existem outros pontos' +
            ' turísticos que merecem destaque, como o <strong>Parque Estadual da Serra de Caldas,</strong> ' +
            'uma unidade de conservação com 120km² criada em 1970, localizado a 5km da cidade.' +
            ' Suas trilhas permitem uma imersão na fauna e na flora do Cerrado brasileiro. ' +
            '<br><br>' +
            'Quer mais sombra e água fresca? Então, a 7km do centro está o <strong>Lago de Corumbá,</strong>' +
            ' um espelho-d’água com 65km², um lugar de natureza abundante, o cenário perfeito para passeios' +
            ' de lancha, barco, jet ski e pesca esportiva.' +
            '<br><br>' +
            'Outro programa imperdível é andar pela <strong>praça central Mestre Orlando</strong>,' +
            ' que abriga a Igreja Matriz Nossa Senhora das Dores, a construção mais antiga da localidade,' +
            ' inaugurada em 1850, e o <strong>Calçadão Orcalino Santos,</strong>' +
            ' com vários bares e restaurantes. Não deixe de experimentar a peculiar culinária da região,' +
            ' como a galinhada com pequi, guariroba e sobremesas com doces de frutas' +
            ' e de leite produzidos artesanalmente.' +
            '<br><br>' +
            'Se relaxar é o que você precisa no momento, arrume as malas e aproveite' +
            ' mais essa opção que a Montreal Viagens oferece a você.',
        recomendacao: [

            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Caldas Novas recebe turistas durante todo o ano, mas vale a pena escolher o período entre' +
            ' maio e setembro, pois o tempo costuma ficar mais firme. A temperatura média anual é de 24º' +
            ' C — durante o verão sobe para 33º C e no inverno cai para 16º C. As chuvas podem ocorrer' +
            ' entre a metade de agosto até o início de junho.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas__demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'Caldas Novas está a aproximadamente 170 km de distância da capital Goiânia, 300 km de Brasília' +
            ' e a 179 km de Uberlândia. É possível chegar ao destino de ônibus, carro ou avião,' +
            ' por meio de voos fretados ou regulares.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop04.jpg'
            }
        ]
    },
    {
        id: 4538,
        titulo: 'Fortaleza ',
        slug: 'fortaleza',
        estado: 'Ceará',
        pais: 'Brasil',
        totalHoteis: 25,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop01.jpg',
        alt: 'Montreal Viagens - Fortaleza',
        resumo: '' +
            'Praias paradisíacas com falésias vermelhas, palmeiras, dunas e lagoas: a capital cearense é a' +
            ' quinta maior cidade do Brasil e conta com um litoral de 34km de extensão. Além do litoral' +
            ' encantador, Fortaleza não vai decepcionar você nos quesitos paisagens paradisíacas, culinária e' +
            ' cultura local.',
        descricao: '' +
            'A <strong>Praia do Futuro</strong> é parada obrigatória para quem planeja conhecer a capital cearense.' +
            ' Um dos pontos mais badalados de Fortaleza, esta praia conta com 8 km de extensão, repletos de' +
            ' barracas que oferecem ao turista estrutura e muito conforto para passar um dia inteiro à' +
            ' beira-mar, aproveitando os comes e bebes mais famosos da região.' +
            '<br><br>' +
            'Quem prefere algo mais tranquilo, pode aproveitar a <strong>Praia do Meireles.</strong>' +
            ' A região é conhecida por ter um mar com poucas ondas e areia firme. Também não deixe de incluir' +
            ' no seu roteiro a <strong>Praia de Iracema, a Ponte dos Ingleses e a Estátua de Iracema,</strong>' +
            ' alguns dos principais pontos turísticos da cidade, além da Prainha, que está próxima ' +
            '<strong>Beach Park</strong> e conta com diversas piscinas naturais durante a maré baixa.' +
            '<br><br>' +
            'Para quem gosta de sair para dançar, o <strong>forró</strong> é um ritmo muito popular na capital' +
            ' cearense. Aos fins de semana, os turistas podem aproveitar o ' +
            '<strong>Centro Dragão do Mar de Arte e Cultura,</strong> popularmente conhecido como Dragão,' +
            ' onde você encontra salas de cinema, teatro, exposições e diversas apresentações musicais.' +
            '<br><br>' +
            'E é claro que não dá para falar de Fortaleza sem lembrar de <strong>Jericoacoara,</strong>' +
            ' não é mesmo? Conhecida como o paraíso cearense, o destino se tornou uma sensação entre os' +
            ' viajantes do Brasil. A vila está localizada a cerca de 300km de Fortaleza e é o destino ideal' +
            ' para quem quer fugir da correria e relaxar em um cenário tão bonito que chega a ser poético.' +
            '<br><br>' +
            'Outro destaque de Fortaleza é o <strong>Beach Park,</strong> uma das principais atrações turísticas' +
            ' do Ceará. Atualmente, o complexo engloba três resorts e um hotel e é a opção perfeita para quem' +
            ' busca conforto e diversão durante as férias.',
        recomendacao: [
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Janeiro, fevereiro e março costumam ser marcados por chuvas frequentes — e muitas vezes para lá' +
            ' de fortes — não só na capital cearense, mas em vários municípios turísticos do interior' +
            ' (como Jericoacoara, Guaramiranga, Canoa Quebrada etc.).',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza__demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'A cidade oferece diversos meios de transporte (ônibus, metrô, VLT, táxi e carros de aplicativo),' +
            ' conectando praticamente todos os pontos de Fortaleza. Uma boa dica é escolher o que sempre' +
            ' for mais seguro para você, principalmente durante a noite.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop04.jpg'
            }
        ]
    },
    {
        id: 7421,
        titulo: 'Florianópolis ',
        slug: 'florianopolis',
        estado: 'Santa Catarina',
        pais: 'Brasil',
        totalHoteis: 16,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop01.jpg',
        alt: 'Montreal Viagens - Florianópolis',
        resumo: '' +
            'Sabe aqueles lugares que, de tão perfeitos, te levam a pensar no paraíso? Florianópolis, a' +
            ' capital de Santa Catarina, está entre os primeiros dessa lista. A viagem à “Ilha da Magia”' +
            'é realmente inesquecível. A cidade atrai turistas brasileiros e estrangeiros por sua gastronomia,' +
            ' história e natureza singular.',
        descricao: '' +
            'As 42 praias catarinenses encantam os viajantes. <strong>Jurerê,</strong> a queridinha de ricaços' +
            ' e celebridades, tem mar calmo, areias finas e uma excelente infraestrutura, com beach clubs que' +
            ' abrem aos finais de semana, bares, restaurantes e shopping center.' +
            '<br><br>' +
            'A vida noturna é bem agitada, com uma intensa programação de shows e festas. As praias da' +
            '<strong>Joaquina</strong>, do Santinho e a Mole – assim chamada por suas areias fofas – são' +
            ' o destino certo para surfistas, praticantes de sandboard e amantes de parapente.' +
            '<br><br>' +
            'A intocada <strong>Lagoinha do Leste</strong> é de perder o fôlego. Entretanto, para chegar lá é' +
            ' preciso enfrentar uma trilha com certo grau de dificuldade. A exuberância da paisagem compensa,' +
            ' e muito, o esforço. ' +
            '<br><br>' +
            'As águas verdes e calmas de <strong>Canasvieiras</strong> se tornaram point dos argentinos, ' +
            'que invadem essas areias na alta temporada. A <strong>Praia do Campeche</strong>, com ótimas ondas, ' +
            'belas dunas e vegetação preservada, reserva um bônus nos meses de setembro e outubro:' +
            ' a possibilidade de avistar baleias e golfinhos. Vale ainda uma esticada à ' +
            '<strong>Ilha do Campeche</strong>, única ilha brasileira tombada como Patrimônio Arqueológico' +
            ' e Paisagístico Nacional.' +
            '<br><br>' +
            'Outra parada obrigatória é a <strong>Lagoa da Conceição.</strong> O mirante, no alto do morro,' +
            ' proporciona uma vista privilegiada. O <strong>“centrinho” da Lagoa e a Avenida das Rendeiras</strong>' +
            ' são repletos de bares, restaurantes e casas noturnas.' +
            '<br><br>' +
            'Um dos marcos da cidade, a <strong>Ponte Hercílio Luz</strong>, construída em 1926 para fazer' +
            ' a ligação com o continente, tem uma estrutura que impressiona.',
        recomendacao: [
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Como o clima por lá costuma ser mais frio, o conselho para quem quer aproveitar a praia' +
            ' é viajar entre os meses de setembro e outubro.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'Se você não vai viajar de carro ou não pretender alugar um em sua viagem, não se preocupe.' +
            ' Florianópolis conta com um sistema de transporte público com ônibus que conectam os' +
            ' diversos pontos da cidade. Outras opções são os táxis, aplicativos de transporte e quem tiver' +
            ' pique, pode alugar bicicletas para fazer um passeio pela cidade.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop04.jpg'
            },
            {
                url: 'https://picsum.photos/400/400?random'
            }
        ]
    },
    {
        id: 5853,
        titulo: 'Brasília ',
        slug: 'brasilia',
        estado: 'Distrito Federal',
        pais: 'Brasil',
        totalHoteis: 32,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop01.jpg',
        alt: 'Montreal Viagens - Brasília',
        resumo: '' +
            'Erguida em pleno Planalto Central em tempo recorde – as obras começaram em 1956 e' +
            ' a nova capital foi inaugurada em 1960 - <strong>Brasília</strong> é tão linda e singular que foi a' +
            ' primeira e única cidade moderna no mundo a receber da Unesco o título de Patrimônio Cultural' +
            ' da Humanidade. ' +
            '<br><br>' +
            'O projeto de urbanização criado por <strong>Lúcio Costa</strong> define os espaços de trabalho,' +
            ' moradia, serviços e lazer, em harmonia com as largas avenidas arborizadas, lagos e' +
            ' jardins assinados pelo paisagista <strong>Roberto Burle Marx.</strong> Impressionam também os' +
            ' marcos da arquitetura modernista, que rompem o horizonte cheios de curvas e' +
            ' ângulos, traços do genial arquiteto <strong>Oscar Niemeyer</strong>',
        descricao: '' +
            'A capital do país é interessante e cheia de história.  Tem pontos turísticos incríveis, não' +
            ' limitados apenas ao turismo cívico, mas também a roteiros de ecoturismo, turismo de' +
            ' aventura, misticismo, esoterismo e até ufologia.' +
            '<br><br>' +
            'O centro do poder fica na <strong>Praça dos Três Poderes,</strong> onde estão o ' +
            '<strong>Palácio do Planalto,</strong> o <strong>Congresso Nacional</strong> e o ' +
            '<strong>Supremo Tribunal Federal</strong> e esculturas como o icônico <strong>Os Guerreiros,</strong>' +
            ' mais conhecida como <strong>Dois Candangos; A Justiça; o Pombal</strong> e a ' +
            '<strong>Pira da Pátria.</strong>' +
            '<br><br>' +
            'Saindo da praça, tem início a <strong>Esplanada dos Ministérios.</strong> De um lado, ' +
            'o belo <strong>Palácio do Itamaraty</strong>, que fascina por seus arcos esplendorosos e o' +
            ' espelho d’água que o circunda. Do lado oposto, o <strong>Palácio da Justiça,</strong>' +
            ' marcado pela geometria retangular, com cascatas que desaguam no espaço' +
            ' com plantas tropicais da Amazônia.' +
            '<br><br>' +
            'Mais adiante está a imponente <strong>Catedral de Brasília</strong>, o primeiro monumento da capital' +
            ' federal. No interior, pendem do teto <strong>Os Anjos,</strong>' +
            ' três esculturas suspensas por cabos de aço. As peças são de Alfredo Ceschiatti e Dante Croce,' +
            ' que também assinam <strong>Os Evangelistas,</strong> as quatro estátuas em bronze com 3m de altura,' +
            ' representando Mateus, Marcos, Lucas e João. Bem ao lado, estão o ' +
            '<strong>Museu e a Biblioteca Nacional,</strong> que compõem o ' +
            '<strong>Conjunto Cultural da República.</strong>' +
            '<br><br>' +
            'Marco visual do Eixo Monumental, a <strong>Torre de TV</strong> foi inaugurada em 1967 para receber' +
            ' antenas de emissoras de rádio e TV. Vale dar uma esticada até o outro lado rua para' +
            ' conhecer o <strong>Estádio Mané Garrincha.</strong>' +
            '<br><br>' +
            'Na orla do <strong>Lago Paranoá,</strong> o <strong>Pontão do Lago Sul</strong> é perfeito para' +
            ' caminhar ou aproveitar os bares e restaurantes. ',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'A melhor época para aproveitar tudo o que Brasília tem a oferecer vai de abril a junho,' +
            ' quando chove pouco e a temperatura é amena e agradável. Depois disso, a baixa' +
            ' umidade relativa pode incomodar, porém é quando o azul do céu se tinge de rosa, lilás,' +
            ' amarelo e laranja, proporcionando um pôr-do-sol espetacular. ',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'Se você está planejando uma viagem para Brasília, lembre-se que a Capital é conhecida por' +
            ' suas longas distâncias entre um ponto turístico e outro. Por isso, o ideal é que você alugue um' +
            ' carro para que o seu roteiro de viagem fique mais flexível e menos oneroso. Se optar pelo' +
            ' transporte público, a cidade oferece ônibus que circulam entre os pontos mais centrais, além' +
            ' de metrô e BRT que conectam algumas cidades do DF à região central de Brasília. Outras' +
            ' opções são os táxis e os carros de aplicativos.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop04.jpg'
            }
        ]
    },
    {
        id: 5864,
        titulo: 'Pirenópolis ',
        slug: 'pirenopolis',
        estado: 'Goiás',
        pais: 'Brasil',
        totalHoteis: 13,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop01.jpg',
        alt: 'Montreal Viagens - Pirinópolis',
        resumo: '' +
            'Tombada pelo Instituto do Patrimônio Histórico e Artístico Nacional (IPHAN), <strong>Pirenópolis</strong>' +
            ' chama atenção pelo seu conjunto arquitetônico - com casarões históricos, ruas de paralelepípedos e' +
            ' igrejas em estilo colonial - e pela beleza natural, com inúmeras cachoeiras, picos e mirantes.',
        descricao: '' +
            'Ao passear pela cidade, o turista tem a sensação de contemplar uma vila do século XVIII. Mas' +
            ' não se iluda. Nos últimos anos, o município vem desabrochando e ganhando glamour, com' +
            ' pousadas espetaculares e bistrôs elegantes, que atraem gourmets do mundo todo, mostrando' +
            ' todo o seu potencial como uma das mais interessantes rotas turísticas do Centro-Oeste.' +
            '<br><br>' +
            'Situada a 140km de Brasília e a 130km de Goiânia, a região atrai visitantes prontos para' +
            ' vivenciar um momento de tranquilidade, aventureiros à procura de adrenalina e interessados' +
            ' na agitação cultural do local. ' +
            '<br><br>' +
            'Entre os principais pontos turísticos de <strong>Piri</strong>, como é carinhosamente chamada,' +
            ' estão a <strong>Igreja Matriz de Nossa Senhora do Rosário</strong>, cuja construção teve início em' +
            ' 1728, considerada pelos goianos o maior centro da fé católica do país; o ' +
            '<strong>Teatro de Pirenópolis; os Museus das Cavalhadas e da Família Pompeu;</strong>' +
            ' as <strong>Igrejas do Bonfim e do Carmo</strong>; as ' +
            '<strong>Ruas do Bonfim, Direita, Aurora e do Rosário</strong>; e as ' +
            '<strong>ruínas do garimpo de ouro</strong> de três séculos atrás. ' +
            '<br><br>' +
            'Para os mais tranquilos, além dos banhos nas cachoeiras, não faltam atrações culturais.' +
            '<br><br>' +
            'Pirenópolis também conquistou o direito de ser reconhecida como um dos polos de gastronomia da' +
            ' região. Além da típica culinária goiana, que atiça o paladar com pratos como arroz com pequi,' +
            ' empadão goiano, pamonha, paçoca de pilão e uma grande variedade de doces em compota caseiros' +
            ' servidos nos estabelecimentos da terra, a cidade também conta com restaurantes mais sofisticados,' +
            ' que incluíram em seus cardápios elaborados ingredientes típicos, tais como castanha de baru,' +
            ' guariroba e pequi.' +
            '<br><br>' +
            'Na <strong>Rua do Rosário,</strong> apropriadamente chamada de <strong>Rua do Lazer,</strong> ' +
            'há uma concentração de barzinhos, bistrôs e restaurantes, quase todos com música ao vivo.' +
            ' Os preços variam um pouco, mas existem opções para todos os bolsos.' +
            '<br><br>' +
            'Quem curte atividades mais radicais tem a opção de desbravar as trilhas ecológicas da ' +
            '<strong>Serra dos Pireneus.</strong> Nas <strong>cachoeiras do Abade e do Rosário</strong> ' +
            'pode-se fazer rapel. Também há rios onde se pratica rafting, canoagem e boiacross. ' +
            'O circuito de aventura no <strong>Santuário de Vida Silvestre Vagafogo</strong>' +
            ' oferece atividades como arvorismo, rapel (em um jatobá centenário), pêndulos (em um vão de 10m) e' +
            ' tirolesas com vistas panorâmicas. Vale ainda uma visita ao <strong>Parque Nacional dos Pireneus</strong>,' +
            ' reserva natural de 2.833 hectares com vegetação de cerrado, onde está o Pico dos Pireneus, maciço' +
            ' de 1.385m de altura, situado na divisa entre Cocalzinho de Goiás e Pirenópolis.',
        recomendacao: [
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'O clima é um fator preponderante para quem está planejando uma viagem para Pirenópolis.' +
            ' Isto porque quando se trata de cachoeiras, chuvas fortes podem impossibilitar o acesso às trilhas' +
            ' ou tornar os banhos muito arriscados, já que podem ocorrer alagamentos e trombas d’água. Por isso,' +
            ' o melhor período para visitar a cidade goiana é entre maio e julho, quando as chuvas já passaram' +
            ' e as quedas d’água das cachoeiras ainda estão cheias.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: 'A melhor opção para quem deseja visitar Pirenópolis é ir até a cidade de carro próprio ou alugado.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop04.jpg'
            }
        ]
    },
    {
        id: 1,
        titulo: 'São Paulo',
        slug: 'sao-paulo',
        estado: 'São Paulo',
        pais: 'Brasil',
        totalHoteis: 53,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop01.jpg',
        alt: 'Montreal Viagens - São Paulo',
        resumo: '' +
            'A maior metrópole do país conquista visitantes com sua história, vida intensa, opções gastronômicas' +
            ' e variada programação cultural. Se você enxerga <strong>São Paulo</strong> apenas como o centro' +
            ' financeiro da América do Sul, saiba que a chamada “Terra da Garoa” pode oferecer muito mais' +
            ' a seus visitantes.',
        descricao: '' +
            'Comece a viagem pelo <strong>Marco Zero</strong>, um monumento de mármore em formato hexagonal' +
            ' instalado na <strong>Praça da Sé.</strong> Dali pode-se explorar o Centro Histórico,' +
            ' onde se encontra a Catedral da Sé, um dos cinco maiores templos neogóticos do mundo,' +
            ' projetada pelo arquiteto alemão Maximilian Hehl.' +
            '<br><br>' +
            'Pegue o metrô e desça na <strong>Estação da Luz.</strong> Aberta desde 1901, seu projeto foi' +
            ' inspirado na Abadia de Westminster, de Londres. Explore o <strong>Parque da Luz,</strong>' +
            ' o <strong>Museu da Língua Portuguesa</strong>, a <strong>Pinacoteca</strong> – que conta com um ' +
            'acervo de mais de nove mil peças – e o <strong>Complexo Cultural Júlio Prestes.</strong> ' +
            'Se for em um domingo de manhã, dá para assistir à apresentação da ' +
            '<strong>Orquestra Sinfônica do Estado de São Paulo,</strong> de graça.' +
            '<br><br>' +
            'Próxima parada? <strong>Praça da República.</strong> Palco de importantes manifestações políticas,' +
            ' também é famosa por abrigar a maior e mais antiga ' +
            '<strong>Feira de Arte e Artesanato de São Paulo,</strong> com mais de 600 barracas.' +
            '<br><br>' +
            'Se você é hardcore, vá direto para a <strong>Galeria do Rock</strong>, onde é possível encontrar' +
            ' roupas, vinis, estúdios de piercing e tatuagem, lojas de skate e acessórios e muitas outras' +
            ' opções ligadas a esse estilo de vida. ' +
            '<br><br>' +
            'E, se bater a fome, não se preocupe. Na Rua Cantareira, 306, está o <strong>Mercado Municipal.</strong> ' +
            'Vale conferir o espaço gastronômico e o tradicional sanduíche de mortadela, um “lanchinho” ' +
            'composto de pão, uma porção de 300 gramas de mortadela e incrementado com queijo e até bacon.' +
            '<br><br>' +
            'Mas, se você prefere algo na linha oriental, rume para o <strong>bairro da Liberdade</strong>,' +
            ' reduto da cultura japonesa. É impossível sair de lá sem provar combinações inusitadas e com' +
            ' um souvenir típico.' +
            '<br><br>' +
            'Por falar em presentinhos, a região também conta com a célebre Rua 25 de Março, um dos maiores' +
            ' centros de compras populares do mundo.' +
            '<br><br>' +
            'Outro tour que vale a pena é o da <strong>Avenida Paulista/Jardins</strong>, ' +
            'uma das áreas mais agitadas de Sampa. ' +
            '<br><br>' +
            'Visite o <strong>Museu de Arte de São Paulo (MASP).</strong> Em seu acervo permanente, obras de arte' +
            ' de Cândido Portinari, Renoir, Vincent van Gogh, Velásquez e vários outros artistas renomados.' +
            ' A construção, sustentada por quatro pilares, possui um enorme vão livre de 74 metros, pensado' +
            ' para preservar a vista do centro da cidade. ' +
            '<br><br>' +
            'Com mais de 1,5 mil km², o <strong>Parque Ibirapuera</strong> é uma das principais áreas de lazer da cidade,' +
            ' com lagos e quadras esportivas, além de um importante conjunto arquitetônico e cultural.' +
            '<br><br>' +
            'Já as regiões da <strong>Vila Madalena e Pinheiros</strong>, os locais mais descolados de São Paulo,' +
            ' agradam em cheio por sua variedade de galerias, ateliês, moda, grafites, livrarias, exposições' +
            ' e feiras em cada esquina. ' +
            '<br><br>' +
            'O <strong>Beco do Batman,</strong> situado nas ruas Gonçalo Afonso e Medeiros de Albuquerque,' +
            ' congrega todos os principais artistas do Movimento Grafite paulistano. ',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'A maior cidade do Brasil, tem alta demanda de turismo em praticamente todas as épocas do ano, porém,' +
            ' se quiser pegar temperaturas mais amenas, viaje de março a junho ou entre setembro e dezembro.' +
            ' O outono e a primavera são as melhores estações para fazer passeios em São Paulo. Neste período,' +
            ' a média de temperatura é de 20°C.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'Se quiser fugir do trânsito, a melhor opção é o transporte público da cidade, que conta com ônibus,' +
            ' microônibus, metrô e trens em um sistema totalmente integrado. Para quem prefere se locomover de' +
            ' táxi ou usando aplicativos, a cidade também oferece muitas opções. Porém, caso opte por chamar um' +
            ' carro de aplicativo, mais uma vez se atente ao horário em que fará a corrida, já que as faixas' +
            ' exclusivas só permitem a passagem de ônibus e táxis. ',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop04.jpg'
            }
        ]
    },
    {
        id: 889,
        titulo: 'Rio de Janeiro',
        slug: 'rio-de-janeiro',
        estado: 'Rio de Janeiro',
        pais: 'Brasil',
        totalHoteis: 69,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop01.jpg',
        alt: 'Montreal Viagens - Rio de Janeiro',
        resumo: '' +
            'A capital carioca é o destino preferido de muitos turistas. Engana-se quem pensa que é preciso um' +
            ' alto investimento para passear por lá: há diversas coisas para fazer de graça no ' +
            '<strong>Rio de Janeiro</strong> e que vão tornar a sua viagem ainda mais especial. ',
        descricao: '' +
            'Cheia de encantos mil, a <strong>Cidade Maravilhosa</strong> é praticamente toda um cartão-postal.' +
            ' Destaque para o complexo de morros do <strong>bairro da Urca</strong>, composto pelo' +
            ' <strong>Pão de Açúcar, Morro da Urca</strong> e <strong>Morro da Babilônia.</strong>' +
            '<br><br>' +
            'O <strong>Corcovado,</strong> onde está a estátua do <strong>Cristo Redentor</strong>, a mais de' +
            ' 700m acima do nível do mar, é apontado como uma das Sete Maravilhas do Mundo Moderno' +
            '<br><br>' +
            'O <strong>Parque das Ruínas em Santa Teresa</strong>, com um mirante que proporciona uma visão 360°' +
            ' do Rio de Janeiro e rende fotos incríveis. ' +
            '<br><br>' +
            'Quer tentar também um pôr do sol? Vá para a <strong>praia do Arpoador</strong>. Inesquecível!' +
            ' A paisagem por lá é exuberante. Entretanto, o espaço pode ser bastante concorrido, especialmente' +
            ' durante o verão e em épocas de alta temporada.' +
            '<br><br>' +
            'Há muitos locais com importância histórica, cultural e paisagens incríveis que valem a pena a' +
            ' conhecer. Aproveite a viagem para conhecer o bairro de <strong>Santa Teresa</strong>, que é um dos' +
            ' pontos mais charmosos da cidade e ainda conta com programação cultural e bons bares e restaurantes.' +
            ' Contudo, é preciso se preparar para as ladeiras da região: vá com um sapato confortável' +
            ' e se hidrate durante o percurso. ' +
            '<br><br>' +
            'O passeio de bondinho, que liga o bairro com a <strong>Lapa</strong> é um dos pontos altos e uma' +
            ' estratégia para facilitar o trajeto, mas a tarifa custa R$20 com a volta inclusa. ' +
            '<br><br>' +
            'O <strong>Parque Lage</strong> é outro local bastante famoso e é mais uma das coisas para fazer de ' +
            'graça no Rio de Janeiro. Ele fica aos pés do <strong>Morro do Corcovado</strong> e conta com uma' +
            ' extensa área verde. O parque tem uma grande importância e foi tombado como patrimônio histórico' +
            ' e cultural da cidade.' +
            '<br><br>' +
            'Outro ponto alto da cidade é a <strong>Pedra Bonita</strong>, um bom local para ver o Rio de Janeiro' +
            ' do alto. Para chegar até lá é preciso enfrentar uma caminhada de cerca de 30 minutos em um percurso' +
            ' um pouco íngreme, mas o esforço vale a pena já que a vista é incrível! De lá você conseguirá' +
            ' observar a zona oeste, a <strong>Floresta da Tijuca</strong>, a <strong>Pedra da Gávea</strong>,' +
            ' entre outros.',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Se você quiser aproveitar o calor carioca, viaje entre novembro e fevereiro. De março a maio,' +
            ' as temperaturas são mais amenas, mas há mais chance de chuvas e dias nublados.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'Se quiser fugir do trânsito, a melhor opção é o transporte público da cidade, que conta com ônibus,' +
            ' metrô e trens em um sistema totalmente integrado. Para quem prefere se locomover de táxi ou usando' +
            ' aplicativos, a cidade também oferece muitas opções. Porém, dependendo da localização do seu hotel,' +
            ' você poderá fazer muitos passeios a pé.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop04.jpg'
            }
        ]
    },
    {
        id: 2796,
        titulo: 'Salvador',
        slug: 'salvador',
        estado: 'Bahia',
        pais: 'Brasil',
        totalHoteis: 24,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop01.jpg',
        alt: 'Montreal Viagens - Salvador',
        resumo: '' +
            'A primeira Capital do Brasil Colônia, entre 1549 e 1763, é repleta de história, tradições, cultura,' +
            ' belezas e uma musicalidade que encantam os viajantes. Formada por uma mistura de etnias, essa' +
            ' fusão está refletida por toda parte.',
        descricao: '' +
            'O acervo arquitetônico e paisagístico de <strong>Salvador</strong> tem cerca de 3 mil edifícios' +
            ' construídos nos séculos XVIII, XIX e XX. Fundada sobre uma falha geográfica de aproximadamente 75 ' +
            'metros, a cidade está dividida em <strong>Cidade Alta e Cidade Baixa</strong>, que se comunicam' +
            ' pelas extensas ladeiras da região ou pelo <strong>Elevador Lacerda</strong> – uma obra do' +
            ' engenheiro baiano Antônio de Lacerda, concluída em 1873, que proporciona uma maravilhosa vista da ' +
            '<strong>Baía de Todos os Santos.</strong>' +
            '<br><br>' +
            'Nomeado Patrimônio Cultural da Humanidade pela UNESCO, desde 1985, o ' +
            '<strong>Centro Histórico de Salvador</strong> é um dos pontos turísticos mais procurados pelos' +
            ' visitantes. Formado pelo <strong>Pelourinho</strong>, o <strong>Terreiro de Jesus</strong> e a ' +
            '<strong>Praça da Sé</strong>, o local, que hoje fascina a todos por sua efervescência artística,' +
            ' seus casarões e um colorido singular, nasceu como espaço de castigo para os escravos.' +
            '<br><br>' +
            'Com 50km de extensão, a orla de Salvador é uma das maiores do país. Com águas mornas e piscinas' +
            ' naturais, as praias soteropolitanas são ideais para surf, mergulho e muita diversão.' +
            ' O <strong>Porto da Barra</strong> é uma das mais conhecidas, possui areias grossas e ondas fracas' +
            ' e está cercada por fortes e diversas igrejas. ' +
            '<br><br>' +
            '<strong>Stella Maris</strong>, com recifes e ondas fortes, é uma das mais agitadas, e suas dunas ' +
            'atraem os adeptos do sandboard. Já <strong>Amaralina</strong> possui um extenso calçadão para caminhadas' +
            ' e corridas. Os arrecifes do <strong>Farol da Barra</strong> são ótimos para o mergulho.' +
            ' No <strong>Flamengo,</strong> as areias finas e ondas fortes são point para a galera do surf.' +
            ' <strong>Itapuã</strong> possui uma paisagem belíssima, águas verdes, coqueiros e piscinas naturais.' +
            '<strong> Jardim de Alah</strong> tem um imenso coqueiral e inúmeras atividades esportivas.' +
            ' <strong>Ondina</strong> é uma das mais frequentadas devido às suas piscinas naturais.' +
            ' Rio Vermelho é conhecida por sua agitação noturna e sua ótima gastronomia.' +
            '<br><br>' +
            'Parece um exagero, mas só a capital baiana conta com <strong>372 templos da religião católica.</strong>' +
            ' Não saia de lá sem conhecer essas preciosidades, que revelam tesouros dos séculos passados.' +
            ' Comece com uma das mais antigas, a <strong>Basílica de Nossa Senhora da Conceição da Praia</strong>,' +
            ' datada de 1623.' +
            '<br><br>' +
            'A <strong>Catedral Basílica</strong> é uma das mais ricas de toda a arte barroca luso-brasileira,' +
            ' revestida interna e externamente em lioz – um tipo raro de calcário proveniente de Portugal.' +
            ' E termine com uma das mais deslumbrantes, a <strong>Igreja e Convento de São Francisco,</strong>' +
            ' cujo interior é todo coberto em ouro.' +
            '<br><br>' +
            'Azeite de dendê, leite de coco, frutos do mar, pimenta... A gastronomia baiana consegue uma fusão' +
            ' de sabores e aromas que conquista os paladares nacionais e estrangeiros. Entre os pratos' +
            ' tradicionais estão o caruru, vatapá, acarajé, bobó de camarão, moqueca e abará. ',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'O período de abril a julho é o mais chuvoso na cidade. Para garantir dias de sol na sua viagem,' +
            ' o ideal é conhecer a cidade durante o verão.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'A cidade conta um sistema de transporte público que conecta diversos pontos de Salvador.' +
            ' Para quem prefere se locomover de táxi ou usando aplicativos,' +
            ' a cidade também oferece muitas opções.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop04.jpg'
            }
        ]
    },
    {
        id: 7977,
        titulo: 'Gramado e Canela',
        slug: 'gramado',
        estado: 'Rio Grande do Sul',
        pais: 'Brasil',
        totalHoteis: 28,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop01.jpg',
        alt: 'Montreal Viagens - Gramado',
        resumo: '' +
            'No coração da Serra Gaúcha, <strong>Gramado e Canela</strong> desenvolveram as tradições culturais' +
            ' dos colonizadores portugueses, alemães e italianos. O resultado é uma gastronomia variada' +
            ' e arquitetura bem típica da Europa. ',
        descricao: '' +
            'Em ambas as cidades, as temperaturas variam muito, podendo nevar no inverno e chegar a 30°' +
            ' no verão. A região tem muitos atrativos. O <strong>Parque Estadual do Caracol</strong> fascina pela' +
            ' beleza. Um elevador panorâmico leva à plataforma com 27m de altura, que proporciona uma vista' +
            ' de 360° graus do parque. Vá também ao <strong>Gramadozoo,</strong> um zoológico com uma proposta' +
            ' de educação ambiental e animais exclusivamente da fauna brasileira, mantidos em condições' +
            ' semelhantes ao habitat natural, em viveiros de imersão com vidros blindados.' +
            '<br><br>' +
            'Os mais curiosos não podem perder o <strong>Castelinho Caracol</strong>, um casarão de 1915' +
            ' que mostra a vida na “colônia”; e os museus de ciência, Mundo a Vapor, Dreamland e o da Moda.' +
            ' Os apaixonados por carros têm diversão garantida no <strong>Salão Supercarros,</strong> um' +
            ' showroom dos maiores mitos automotivos do mundo e no Hollywood Dream Cars,' +
            ' uma coleção de automóveis restaurados dos anos 20 aos anos 60. ' +
            '<br><br>' +
            'As crianças vão adorar as miniaturas do <strong>Mini Mundo e da Casa do Capitão Jack.</strong> ' +
            'E certamente confirmarão seus sonhos no <strong>Parque Aldeia do Papai Noel</strong>, vendo renas' +
            ' de verdade. Siga para a <strong>Terra Mágica Florybal</strong>, que mistura duendes, dinossauros,' +
            ' índios, homens pré-históricos e figuras mitológicas; ao <strong>Vale dos Dinossauros,</strong> ' +
            'com réplicas animatrônicas em tamanho natural. Para encerrar, faça uma visita a ' +
            '<strong>Snowland</strong>, um parque de 8.100m² com neve e pista de esqui. ' +
            '<br><br>' +
            'Em Gramado ou Canela experimente o galeto e o famoso café colonial, uma verdadeira disputa de quem' +
            ' serve mais itens à mesa. Alguns lugares chegam a ter cerca de 80 itens diferentes. Não dá para' +
            ' encerrar a visita sem conhecer o típico churrasco gaúcho, não é? ',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Gramado e Canela são destinos muito procurados no inverno, especialmente no mês de julho, quando as' +
            ' temperaturas estão mais baixas. Entre outubro e janeiro a demanda volta a crescer, já que neste ' +
            'período os turistas podem aproveitar o Natal Luz e as decorações natalinas das duas cidades.' +
            ' No verão as temperaturas podem chegar a mais de 30°C. No inverno, a temperatura pode ficar' +
            ' negativa — mas isso não atrapalha em nada os passeios! Além do frio, a neblina e a própria' +
            ' arquitetura conferem às cidades um charme europeu.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado__demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'Uma das melhores opções para quem quer aproveitar Gramado e Canela por conta própria é alugar' +
            ' um carro. Caso opte por fazer os passeios a pé, escolha os hotéis no centro das cidades.' +
            ' Outra opção para quem opta por não alugar um carro são os táxis, que circulam pelas duas cidades.' +
            ' Também há uma linha de ônibus que conecta Gramado e Canela, percorrendo uma distância de 7km. ',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop04.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop05.jpg'
            }
        ]
    },
    {
        id: 14379,
        titulo: 'Porto de Galinhas',
        slug: 'porto-de-galinhas',
        estado: 'Recife',
        pais: 'Brasil',
        totalHoteis: 11,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop01.jpg',
        alt: 'Montreal Viagens - Porto de Galinhas',
        resumo: '' +
            'Porto de Galinhas é uma das primeiras opções de destinos de praia do Brasil. O paraíso pernambucano' +
            ' é conhecido pelo mar de águas verdes onde se formam diversas piscinas naturais. Se você está' +
            ' procurando um destino para relaxar no nordeste brasileiro, <strong>Porto de Galinhas</strong>' +
            ' é a escolha certa.',
        descricao: '' +
            '<strong>Porto de Galinhas</strong> é um distrito de Pernambuco localizado a aproximadamente 60km do' +
            ' Aeroporto Internacional do Recife e atualmente é um dos locais mais visitados por' +
            ' turistas no Nordeste. ' +
            '<br><br>' +
            'Além de ter praias de águas verdes, quentes e calmas, um dos pontos altos de Porto de Galinhas são ' +
            'as <strong>piscinas naturais.</strong> Para acessá-las, pegue as jangadas que partem da ' +
            '<strong>Praia da Vila.</strong> Em dez minutos, você já estará rodeado de peixes e cavalos-marinhos.' +
            ' Dá para chegar às piscinas a pé também, acompanhado por monitores da Prefeitura.' +
            ' A saída é feita no Posto do Praia Legal, da Prefeitura de Ipojuca, que fica na Praça do Relógio' +
            ' e dura em média 30 minutos. ' +
            '<br><br>' +
            'Quem prefere explorar praias mais vazias, deve aproveitar a região norte. ' +
            'A <strong>Praia de Muro Alto</strong> é uma das mais famosas da região. Além de ser mais vazia,' +
            ' a praia tem um cenário paradisíaco, já que é cercada por uma barreira de corais, que formam uma' +
            ' grande piscina natural.' +
            '<br><br>' +
            'Outros destaques deste paraíso nordestino são o artesanato e a culinária locais. Aproveite' +
            ' a <strong>Feirinha de Artesanato de Porto de Galinhas</strong> para fazer compras e garantir suas' +
            ' lembrancinhas de viagem. No que diz respeito à gastronomia, se delicie com os temperos locais ' +
            'e não se esqueça de provar o famoso bolo de rolo de Pernambuco.',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Quem quer aproveitar as praias sem chuva e ainda apreciar as águas do mar mais claras, deve viajar' +
            ' entre setembro e março. E atenção: o período entre dezembro e fevereiro é considerado alta' +
            ' temporada.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'Porto de Galinhas é uma região relativamente pequena. Se você contar com o suporte de um carro na' +
            ' sua viagem, poderá ter mais flexibilidade na hora de traçar as suas rotas.' +
            ' Porém, caminhar é uma ótima opção para os turistas.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop04.jpg'
            }
        ]
    },
    {
        id: 4103,
        titulo: 'João Pessoa',
        slug: 'joao-pessoa',
        estado: 'Paraiba',
        pais: 'Brasil',
        totalHoteis: 30,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop01.jpg',
        alt: 'Montreal Viagens - João Pessoa',
        resumo: '' +
            ' Quem visita João Pessoa, na Paraíba, costuma ficar encantado com a combinação de belas' +
            ' praias, ruas arborizadas, população hospitaleira e um acervo histórico arquitetônico bem' +
            ' conservado. E não é à toa. Jampa, como é carinhosamente conhecida, é a terceira capital mais' +
            ' antiga do país.',
        descricao: '' +
            'As praias urbanas como <strong>Tambaú, Manaíra</strong> e <strong>Cabo Branco</strong>, além de' +
            ' limpas, oferecem toda a infraestrutura para os turistas. Se estiver de carro, aproveite para' +
            ' passear pelo litoral sul, na direção de Pernambuco. As paisagens são mais rústicas e apresentam' +
            ' cenários maravilhosos, como <strong>Carapibus, Tabatinga, Coqueirinho e Tambaba –</strong> ' +
            'o mais famoso endereço naturista do país –, distante apenas 33km da capital.' +
            '<br><br>' +
            'Se o seu negócio é surfar, inverta o destino e vá para o norte, para ' +
            '<strong>Barra de Camaratuba</strong>, a aproximadamente 110km de João Pessoa.' +
            '<br><br>' +
            'Viajando com as crianças? Inclua no roteiro as <strong>piscinas naturais de Picãozinho</strong>,' +
            ' repletas de peixes coloridos, localizadas a menos de 2km da costa, na praia de Tambaú. O tour dura' +
            ' cerca de quatro horas. Mas atenção! As piscinas só se formam durante as luas cheia e nova.' +
            '<br><br>' +
            'Em terra, explore a <strong>Praia do Seixas</strong>, que, além de linda, ostenta ' +
            '<astrong>Ponta do Seixas,</astrong> marco reconhecido como a parte mais oriental das Américas.' +
            ' Ou seja, é aqui que o sol nasce primeiro no Brasil. Por isso, a capital paraibana também é' +
            ' denominada Porta do Sol. Reserve ainda uma parte do dia para o <strong>Centro Cultural São Francisco</strong>,' +
            ' o mais importante conjunto de arte barroca do estado; o ' +
            '<strong>Forte de Santa Catarina do Cabedelo;</strong> e a ' +
            '<strong>Praça Antenor Navarro</strong>, pontilhada de pequenos prédios em estilo art déco. ' +
            '<br><br>' +
            'João Pessoa também tem modernidade, como a <strong>Estação Cabo Branco – </strong> ' +
            'Ciência Cultura e Artes, projetada por Oscar Niemeyer. Para finalizar, não perca o show ' +
            '<destrong> Jurandy do Sax,</destrong> na praia fluvial do Jacaré, que toca o Bolero de Ravel' +
            ' enquanto o sol se põe. O espetáculo acontece há mais de 15 anos, sempre às 16h30.' +
            '<br><br>' +
            'A gastronomia da região também impressiona. Além dos frutos do mar, as receitas do sertão, à' +
            ' base de carne de sol e de bode, arroz de leite, feijão-de-corda, macaxeira e manteiga de' +
            ' garrafa, são deliciosas.' +
            '<br><br>' +
            'Com tantas atrações, difícil mesmo é programar o tempo para desfrutar tudo o que a capital' +
            ' paraibana oferece.',
        recomendacao: [

            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'A melhor época para ir à Paraíba é entre setembro e março. A partir de dezembro,' +
            ' a água quente do mar ganha incríveis tonalidades de verde e azul.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa__demanda.jpg',
        demandaDescricao: '*Hotéis em alta temporada podem migrar de plano.',
        transporte: '' +
            'A melhor opção para você aproveitar João Pessoa ao máximo e dar o seu próprio ritmo à' +
            ' viagem é de carro. Se alugar um carro ou viajar de carro próprio não são opções para você,' +
            ' escolha bem a localização do seu hotel. Assim, você poderá fazer caminhadas pelo bairro em' +
            ' que estiver hospedado, mas precisará contar com o auxílio de um táxi ou do transporte público' +
            ' local para se locomover entre um bairro e outro. Outra opção são os trens urbanos, que' +
            ' circulam na região metropolitana da cidade.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop04.jpg'
            }
        ]
    }
];
export const LISTA_DESTINO = [
    {
        id: 5966,
        titulo: 'Caldas Novas',
        slug: 'caldas-novas',
        estado: 'Goiás',
        pais: 'Brasil',
        totalHoteis: 21,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop01.jpg',
        alt: 'Montreal Viagens - Caldas Novas',
        resumo: 'Caldas Novas é um destino que reúne conforto, lazer e experiências de aventura ideais — tanto...',
        descricao: '' +
            'O principal motivo do turismo em Caldas Novas são as nascentes termais da região.' +
            ' Descobertas no século 18, já foram utilizadas para tratamentos de saúde e depois se tornaram' +
            ' um verdadeiro refúgio para os turistas. A fama deu à cidade o título de maior estância' +
            ' hidrotermal do mundo, com águas que brotam do chão em temperaturas que variam entre 35º C' +
            ' a 57º C. Esse paraíso de águas pode ser aproveitado na grande estrutura de lazer criada pelos' +
            ' parques aquáticos. O banho refrescante em meio ao cerrado brasileiro cria um ambiente único' +
            ' e inesquecível. O turista tem a opção de nadar, mergulhar, boiar ou apenas relaxar nas praias' +
            ' artificiais, piscinas e fontes. Além disso, a cultura musical do centro-oeste também é um ' +
            'atrativo turístico. O pop sertanejo movimenta a cidade durante os finais de semana, feriados' +
            ' prolongados e temporada de férias. Há diversas casas de shows, boates e eventos voltados para' +
            ' este estilo musical. Caldas Novas está a aproximadamente 170 km de distância da capital ' +
            'Goiânia, 300 km de Brasília e a 179 km de Uberlândia. É possível chegar ao destino de ônibus, ' +
            'carro ou avião, por meio de voos fretados ou regulares (Azul e Gol).',
        recomendacao: [

            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Caldas Novas recebe turistas durante todo o ano, mas vale a pena escolher o período entre maio' +
            ' a setembro pois o tempo costuma ficar mais firme. A temperatura média anual é de 24º C — durante' +
            ' o verão sobe para 33º C e no inverno cai para 16º C. As chuvas podem ocorrer entre a metade de' +
            ' agosto até o início de junho.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas__demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: 'A opção mais utilizada por turistas que não viajam com o carro próprio são táxis ou carros alugados.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Caldas_Novas/caldas_desktop04.jpg'
            }
        ]
    },
    {
        id: 4538,
        titulo: 'Fortaleza ',
        slug: 'fortaleza',
        estado: 'Ceará',
        pais: 'Brasil',
        totalHoteis: 25,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop01.jpg',
        alt: 'Montreal Viagens - Fortaleza',
        resumo: 'Fortaleza é um dos principais destinos de turistas que desejam conhecer o nordeste brasileiro...',
        descricao: '' +
            'Em termos de litoral, a Praia do Futuro é parada obrigatória para quem planeja conhecer a capital' +
            ' cearense. Um dos pontos mais badalados de Fortaleza, a praia conta com 8 km de extensão repletos' +
            ' de barracas, que oferecem ao turista a estrutura e o conforto ideais para passar um dia inteiro à' +
            ' beira-mar, aproveitando os comes e bebes mais famosos da região. Quem prefere algo mais tranquilo,' +
            ' pode aproveitar a Praia do Meireles. A região é conhecida por ter um mar com poucas ondas e areia' +
            ' firme. Também não deixe de incluir no seu roteiro a Praia de Iracema, a Ponte dos Ingleses e a' +
            ' Estátua de Iracema, alguns dos principais pontos turísticos da cidade, além da Prainha, que está' +
            ' próxima ao Beach Park e conta com diversas piscinas naturais durante a maré baixa. A vida noturna ' +
            'de Fortaleza é outro ponto alto da cidade. São diversas opções de festas, bares e restaurantes que ' +
            'funcionam praticamente todos os dias da semana. Para quem gosta de sair para dançar, o forró é um' +
            ' ritmo muito popular na capital cearense. Aos fins de semana, os turistas podem aproveitar o Centro' +
            ' Dragão do Mar de Arte e Cultura, popularmente conhecido como Dragão, onde você encontra salas de' +
            ' cinema, teatro, exposições e diversas apresentações musicais. O point ideal para um happy hour.' +
            ' E é claro que não dá pra falar de Fortaleza sem lembrar de Jericoacoara, não é mesmo? Conhecida' +
            ' como o paraíso cearense, o destino se tornou uma sensação entre os viajantes do Brasil.' +
            ' A vila está localizada a cerca de 300km de Fortaleza e é o destino ideal para quem quer fugir' +
            ' da correria e relaxar em um cenário tão bonito que chega a ser poético. Por lá, você pode' +
            ' aproveitar a Praia de Jeri, ideal para a prática de windsurf e desfrutar dos principais bares,' +
            ' restaurantes e hotéis de Jericoacoara. Outro ponto alto de Jeri são as Dunas do Pôr do Sol,' +
            ' um dos símbolos da cidade. Reserve ao menos um fim de tarde do seu roteiro para passar por lá.' +
            ' Também não deixe de conhecer a Pedra Furada, que é considerada um dos principais cartões postais' +
            ' da vila. Lá, você encontrará uma fenda no meio do mar e, em determinado momento do dia, ' +
            'você pode ver o pôr do sol acontecer “dentro” dela. Outro destaque de Fortaleza é o Beach Park,' +
            ' uma das principais atrações turísticas do Ceará. Atualmente, o complexo engloba três resorts e' +
            ' um hotel e é a opção perfeita para quem busca conforto e diversão durante as férias.' +
            ' Localizado na praia de Porto das Dunas, a estrutura do Beach Park oferece opções para o público' +
            ' geral, que incluem os restaurantes da Vila Azul e as barracas da Praia de Porto das Dunas. ' +
            'O complexo também conta com atrações exclusivas para o público pagante. Caso opte por passar um' +
            ' dia ou comprar o passaporte do parque aquático, prepare-se para se divertir bastante. ' +
            'Uma das atrações mais famosas é o toboágua Insano, brinquedo onde você desce 41 metros' +
            ' de altura em 5 segundos!',
        recomendacao: [
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Janeiro, fevereiro e março costumam ser marcados por chuvas frequentes — e muitas vezes para lá' +
            ' de fortes — não só na capital cearense, mas em vários municípios turísticos do interior' +
            ' (como Jericoacoara, Guaramiranga, Canoa Quebrada etc.).',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza__demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'A cidade oferece diversos meios de transporte (ônibus, metrô, VLT, táxi e carros de aplicativo),' +
            ' conectando praticamente todos os pontos de Fortaleza. Uma boa dica é escolher o que sempre for' +
            ' mais seguro para você, principalmente durante a noite.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Fortaleza/fortaleza_desktop04.jpg'
            }
        ]
    },
    {
        id: 7421,
        titulo: 'Florianópolis ',
        slug: 'florianopolis',
        estado: 'Santa Catarina',
        pais: 'Brasil',
        totalHoteis: 16,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop01.jpg',
        alt: 'Montreal Viagens - Florianópolis',
        resumo: 'Conhecida como “Ilha da Magia”, a capital catarinense é um destinos mais queridos por estrangeiros...',
        descricao: '' +
            'É claro que não dá para falar de Florianópolis sem mencionar as belíssimas praias que compõem a' +
            ' capital de Santa Catarina. Ao todo, são 42 praias que proporcionam paisagens paradisíacas e tem' +
            ' opções para todos os gostos. Uma das regiões mais famosas de Floripa são Jurerê e Jurerê Internacional.' +
            ' Os dois bairros se dividem entre casas de veraneio e resorts de luxo e contam com lindas praias,' +
            ' como a Praia de Canasvieiras e a Praia do Forte. Em Canasvieiras, crianças menores podem ficar à' +
            ' vontade e aproveitar as águas tranquilas e mornas. Apesar da pouca extensão de areia, a praia é bastante' +
            ' frequentada pelos turistas, principalmente por ser de fácil acesso à cidade e o lugar ideal para recuperar' +
            ' as energias para aproveitar a noite de Floripa. Uma das grandes atrações noturnas da cidade é a boate' +
            ' internacional Pacha. O espaço é um verdadeiro paraíso para quem gosta de música eletrônica.' +
            ' Você vai dançar e curtir cada minuto que estiver por lá; e não precisa sair antes de amanhecer.' +
            ' Outro ponto alto da Ilha da Magia é a Praia do Forte, por lá você vai encontrar um ambiente que tem' +
            ' mais ares de natureza e é mais afastado, mas conserva deliciosas águas tranquilas e de boa temperatura.' +
            // tslint:disable-next-line:max-line-length
            ' Se você for passar o dia lá, não deixe de conhecer a Fortaleza de São José e ter uma visão panorâmica do mar.' +
            // tslint:disable-next-line:max-line-length
            ' Quem gosta de badalação e ostentação pode conhecer as boates e restaurantes de luxo de Jurerê Internacional.' +
            ' A praia que leva o mesmo nome lembra uma versão brasileira de Miami, e quem visita pode observar' +
            ' carros e mansões luxuosas. Essa região norte da ilha de Florianópolis tem atrações para todos ' +
            'os gostos, se tornando um complexo de praias excelente para planejar uma viagem de férias ou visitas curtas.',
        recomendacao: [
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Como o clima por lá costuma ser mais frio, o conselho para quem quer aproveitar a praia é viajar' +
            ' entre os meses de setembro e outubro.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'Se você não vai viajar de carro ou não pretender alugar um carro na viagem, não se preocupe.' +
            ' Florianópolis conta com um sistema de transporte público com ônibus que conectam os diversos' +
            ' pontos da cidade. Outras opções são os táxis, aplicativos de transporte e quem tiver pique também' +
            ' pode alugar bicicletas para fazer um passeio pela cidade.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Florianopolis/floripa_desktop04.jpg'
            },
            {
                url: 'https://picsum.photos/400/400?random'
            }
        ]
    },
    {
        id: 5853,
        titulo: 'Brasília ',
        slug: 'brasilia',
        estado: 'Distrito Federal',
        pais: 'Brasil',
        totalHoteis: 32,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop01.jpg',
        alt: 'Montreal Viagens - Brasília',
        resumo: 'O projeto urbanístico de Lúcio Costa e a arquitetura de Oscar Niemeyer são um convite à fotografia...',
        descricao: '' +
            'Diferente sob todos os aspectos, a Capital Federal é uma cidade cheia de curvas e ângulos, onde' +
            ' o concreto aparente harmoniza com árvores floridas e gramados bem cuidados. E o céu?' +
            ' O “mar dos brasilienses” domina a paisagem e encanta principalmente ao pôr do sol, quando' +
            ' o horizonte azul fica salpicado de tons vermelhos, amarelos e cor-de-rosa. Brasília é, ' +
            'sem dúvidas, muito mais que o centro político do Brasil. A capital vem se tornando um destino' +
            ' cada vez mais procurado por turistas que desejam mergulhar na história e arquitetura dos anos' +
            ' de 1960. Em um passeio pelas áreas centrais da cidade, você vai perceber que Brasília é ' +
            'diferente de tudo que você já viu. Os prédios são mais baixos (de até 6 andares) e não têm ' +
            'cercas entre si. As avenidas são largas e todo o projeto arquitetônico de Oscar Niemeyer foi ' +
            'desenhado com o objetivo de evidenciar o céu, possibilitando que você possa enxergar a imensidão' +
            ' azul de qualquer ponto da cidade. Mas já vou logo te avisando: se você estiver planejando visitar' +
            ' Brasília, prepare sua câmera fotográfica, já que cada canto da cidade é cercado por monumentos' +
            ' arquitetônicos, repletos de curvas e ângulos quase impossíveis de se ver em estruturas de concreto.' +
            ' A Catedral Metropolitana de Brasília, por exemplo, é um dos pontos turísticos obrigatórios da cidade.' +
            // tslint:disable-next-line:max-line-length
            ' Com um projeto arquitetônico de tirar o fôlego, este foi o primeiro monumento a ser criado na Capital Federal.' +
            'Quem tem curiosidade de aprender mais sobre a rotina política do parlamento brasileiro, pode ' +
            'fazer uma visita guiada ao Congresso Nacional. O passeio é gratuito e pode ser agendado ' +
            'com antecedência pelo site. Durante a visita, você vai descobrir curiosidades sobre o período ' +
            'da criação de Brasília, detalhes sobre o projeto de criação da sede do poder brasileiro, ' +
            'de Oscar Niemeyer, além de visitar espaços com o Plenário da Câmara e do Senado. Outro ponto ' +
            'alto de Brasília são as variedades gastronômicas que a cidade oferece. Na Capital Federal, ' +
            'você poderá experimentar uma variedade de comidas típicas, desde especiarias do nordeste até ' +
            'um bom churrasco gaúcho. Não deixe de incluir no seu roteiro o Pontão do Lago Sul, ' +
            'um centro de lazer e gastronomia à beira do Lago Paranoá.',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'O clima da Capital Federal é majoritariamente seco e chuvoso, variando de acordo com o período' +
            ' do ano. Os meses entre julho e setembro são especialmente secos, já o período de chuvas' +
            ' mais intensas ocorre entre novembro e março.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'Se você está planejando uma viagem para Brasília, lembre-se que a Capital é conhecida por suas' +
            ' longas distâncias entre um ponto turístico e outro. Por isso, o ideal é que você alugue um' +
            ' carro para que o seu roteiro de viagem fique mais flexível e menos oneroso. Se optar pelo' +
            ' transporte público, a cidade oferece ônibus que circulam entre os pontos mais centrais,' +
            ' além de metrô e BRT que conectam algumas cidades do DF à região central de Brasília.' +
            ' Outras opções são os táxis e os carros de aplicativos. Porém, se você planejar sua viagem' +
            ' utilizando somente estes meios de transporte, faça os cálculos antes, pois as longas distâncias' +
            ' de Brasília podem onerar os valores das corridas.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Brasilia/brasilia_desktop04.jpg'
            }
        ]
    },
    {
        id: 5864,
        titulo: 'Pirenópolis ',
        slug: 'pirenopolis',
        estado: 'Goiás',
        pais: 'Brasil',
        totalHoteis: 13,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop01.jpg',
        alt: 'Montreal Viagens - Pirinópolis',
        resumo: 'Pousadas e restaurantes sofisticados fazem da cidade goiana um polo do turismo de aventura, cultura...',
        descricao: '' +
            'Ao passear pela cidade, o turista tem a sensação de contemplar uma vila do século XVIII. ' +
            'Mas não se iluda. Nos últimos anos, o município vem desabrochando e ganhando glamour, com ' +
            'pousadas espetaculares e bistrôs elegantes, que atraem turistas do Brasil inteiro, já que a ' +
            'cada ano Pirenópolis vem consolidando seu potencial como uma das mais interessantes rotas ' +
            'turísticas do Centro-Oeste. Situada a 140 km de Brasília e a 130 km de Goiânia, a região atrai' +
            ' visitantes prontos para vivenciar um momento de tranquilidade, aventureiros à procura de ' +
            'adrenalina e também interessados na agitação cultural e gastronômica. Diversão é o que não ' +
            'falta. Durante o ano todo, a cidade recebe festivais, shows e competições esportivas variadas. ' +
            'Entre os principais pontos turísticos de Piri, como é carinhosamente chamada, estão a Igreja ' +
            'Matriz de Nossa Senhora do Rosário, considerada pelos goianos o maior centro da fé católica do' +
            ' País. Além do Teatro de Pirenópolis, os Museus das Cavalhadas e da Família Pompeu, as Igrejas ' +
            'do Bonfim e do Carmo, a Casa de Câmara e Cadeia, as Ruas do Bonfim, Direita, Aurora e do Rosário' +
            ' e as ruínas do garimpo de ouro de três séculos atrás. Para os mais tranquilos, além dos banhos' +
            ' nas cachoeiras, pirenópolis é reconhecida como um dos polos de gastronomia da região. Além da ' +
            'típica culinária goiana, que atiça o paladar com pratos como arroz com pequi, empadão goiano, ' +
            'pamonha, paçoca de pilão e uma grande variedade de doces em compota, a cidade também conta com ' +
            'restaurantes mais sofisticados, que incluíram em seus cardápios ingredientes típicos, tais como' +
            ' castanha de baru, guariroba e pequi. Na Rua do Rosário, também conhecida como Rua do Lazer, há' +
            ' uma concentração de barzinhos, bistrôs e restaurantes, quase todos com música ao vivo. Quem curte' +
            ' atividades mais radicais tem a opção de desbravar as trilhas ecológicas da Serra dos Pireneus,' +
            ' que podem ser percorridas a pé ou de bike. Nas cachoeiras do Abade e do Rosário, você poderá ' +
            'fazer rapel. Também há rios onde os turistas podem praticar rafting, canoagem e bóia cross. ' +
            'Vale ainda uma visita ao Parque Nacional dos Pireneus, reserva natural de 2.833 hectares com ' +
            'vegetação de cerrado, onde está o Pico dos Pireneus, com 1.385m de altura, situado na divisa ' +
            'entre Cocalzinho de Goiás e Pirenópolis.',
        recomendacao: [
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'O clima é um fator preponderante para quem está planejando uma viagem para Pirenópolis. ' +
            'Isto porque quando se trata de cachoeiras, chuvas fortes pode impossibilitar o acesso às ' +
            'trilhas ou tornar os banhos muito arriscados, já que podem ocorrer alagamentos. Por isso, ' +
            'o melhor período para visitar a cidade goiana é entre maio e julho, quando as chuvas já ' +
            'passaram e as quedas d água ainda estão cheias.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: 'A melhor opção para quem deseja visitar Pirenópolis é ir até a cidade de carro próprio ou alugado.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Pirenopolis/pirenopolis_desktop04.jpg'
            }
        ]
    },
    {
        id: 1,
        titulo: 'São Paulo',
        slug: 'sao-paulo',
        estado: 'São Paulo',
        pais: 'Brasil',
        totalHoteis: 53,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop01.jpg',
        alt: 'Montreal Viagens - São Paulo',
        resumo: 'Se você enxerga São Paulo apenas como o centro financeiro da América do Sul, saiba que a chamada...',
        descricao: '' +
            'A maior metrópole do País conquista visitantes com sua história, vida intensa, opções gastronômicas' +
            ' e variada programação cultural. Quer ser surpreendido? Comece a viagem pelo Marco Zero, um monumento' +
            ' de mármore em formato hexagonal instalado na Praça da Sé. Dali pode-se explorar o Centro Histórico,' +
            ' onde se encontra a Catedral da Sé, um dos cinco maiores templos neogóticos do mundo, projetada pelo' +
            ' arquiteto alemão Maximilian Hehl. Mais adiante, na região do Largo do Café, dois prédios bem' +
            ' representativos: a BM&F, fundada em 1890, e o Edifício Martinelli, inaugurado em 1929 e, sem' +
            ' dúvida, um dos melhores lugares para se observar a cidade do alto. Siga até o Mosteiro São Bento,' +
            '  um exemplo típico da arquitetura do século XVII. Pegue o metrô e desça na Estação da Luz.' +
            ' Aberta desde 1901, seu projeto foi inspirado na Abadia de Westminster, de Londres.' +
            ' Explore o Parque da Luz, o Museu da Língua Portuguesa, a Pinacoteca e também o Complexo Cultural' +
            ' Júlio Prestes, onde fica a Sala São Paulo. Se for em um domingo de manhã, ainda dá para assistir' +
            ' à apresentação da Orquestra Sinfônica do Estado de São Paulo, de graça. Próxima parada? ' +
            'Praça da República. Palco de importantes manifestações políticas, também é famosa por abrigar' +
            ' a maior e mais antiga Feira de Arte e Artesanato de São Paulo, com mais de 600 barracas. ' +
            'Se você gosta de arquitetura, o Edifício Copan, uma das maiores obras em concreto armado do país,' +
            ' projetado por Oscar Niemeyer na década de 1950, é ponto obrigatório. Na Galeria do Rock,' +
            ' é possível encontrar roupas, vinis, estúdios de piercing e tatuagem, lojas de skate e acessórios.' +
            ' Outro tour que vale a pena é o da Avenida Paulista/Jardins, uma das áreas mais agitadas de Sampa.' +
            ' Comece pelo icônico Maksoud Plaza, hotel parceiro da Montreal. O hotel – construído no terreno' +
            ' onde antes existiu a primeira Abadia de Freiras Beneditinas das Américas – já foi considerado ' +
            'o mais elegante do Brasil e faz parte da história de São Paulo.',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'A maior cidade do Brasil tem alta demanda de turismo em praticamente todas as épocas do ano, ' +
            'porém, se quiser pegar temperaturas mais amenas, viaje de março a junho ou entre setembro e ' +
            'dezembro. O outono e a primavera são as melhores estações para fazer passeios em São Paulo.' +
            ' Neste período, a média de temperatura é de 20°C',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'Se quiser fugir do trânsito, a melhor opção é o transporte público da cidade, que conta com ônibus,' +
            ' micro-ônibus, metrô e trens em um sistema totalmente integrado. Se optar por este meio de transporte,' +
            ' evite os horários de pico, para escapar da superlotação do transporte público de São Paulo.' +
            ' Para quem prefere se locomover de táxi ou usando aplicativos, a cidade também oferece muitas' +
            ' opções. Porém, caso opte por chamar um carro de aplicativo, mais uma vez se atente ao horário ' +
            'em que fará a corrida, já que as faixas exclusivas só permitem a passagem de ônibus e táxis. ' +
            'Assim, você pode ficar preso no trânsito nos horários de pico. Alugar um carro não é uma boa ' +
            'opção para se locomover em São Paulo durante a sua viagem.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Sao_Paulo/saopaulo_desktop04.jpg'
            }
        ]
    },
    {
        id: 889,
        titulo: 'Rio de Janeiro',
        slug: 'rio-de-janeiro',
        estado: 'Rio de Janeiro',
        pais: 'Brasil',
        totalHoteis: 69,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop01.jpg',
        alt: 'Montreal Viagens - Rio de Janeiro',
        resumo: 'A capital carioca é o destino preferido de muitos turistas e engana-se quem pensa que é preciso...',
        descricao: '' +
            'Cheia de encantos mil, a Cidade Maravilhosa é praticamente toda um cartão-postal. Destaque para' +
            ' o complexo de morros do bairro da Urca, composto pelo Pão de Açúcar, Morro da Urca e Morro da ' +
            'Babilônia; o Corcovado, onde está a estátua do Cristo Redentor, a mais de 700m acima do nível do' +
            ' mar é apontado como uma das Sete Maravilhas do Mundo Moderno; e o Parque das Ruínas em Santa ' +
            'Teresa, com um mirante que proporciona uma visão 360° do Rio de Janeiro e rende fotos incríveis.' +
            ' Quer tentar também um pôr do sol? Vá para a praia do Arpoador. Inesquecível! Aproveitar as praias,' +
            ' sem dúvida, é a principal atividade gratuita que se pode fazer pela cidade, especialmente em ' +
            'dias de sol e calor. Mas ainda há locais com importância histórica, cultural e paisagens incríveis' +
            ' que valem a pena a conhecer. Aproveite a viagem para conhecer o bairro de Santa Teresa, que ' +
            'é um dos pontos mais charmosos da cidade e ainda conta com programação cultural e bons bares e ' +
            'restaurantes. Contudo, é preciso se preparar para as ladeiras da região: vá com um sapato ' +
            'confortável e se hidrate durante o percurso. O passeio de bondinho, que liga o bairro com a ' +
            'Lapa é um dos pontos altos e uma estratégia para facilitar o trajeto, mas a tarifa custa R$20' +
            ' com a volta inclusa. O Parque Lage é outro local bastante famoso e é mais uma das coisas para ' +
            'fazer de graça no Rio de Janeiro. Ele fica aos pés do Morro do Corcovado e conta com uma extensa ' +
            'área verde. O parque tem uma grande importância e foi tombado como patrimônio histórico e cultural ' +
            'da cidade. Uma das tradições de cariocas e turistas é apreciar o pôr do sol na pedra do Arpoador.' +
            ' A paisagem por lá é exuberante, e o melhor: você não precisa pagar nada por isso! Entretanto,' +
            ' o espaço pode ser bastante concorrido, especialmente durante o verão e em épocas de alta temporada.' +
            ' Sendo assim, se você deseja um bom lugar para ver esse espetáculo da natureza, procure chegar cedo.' +
            ' Outro ponto alto da cidade é a Pedra Bonita, um bom local para ver o Rio de Janeiro do alto. ' +
            'Para chegar até lá é preciso enfrentar uma caminhada de cerca de 30 minutos em um percurso um ' +
            'pouco íngreme, mas o esforço vale a pena já que a vista é incrível! De lá você conseguirá observar ' +
            'a zona oeste, a Floresta da Tijuca, a Pedra da Gávea, entre outros pontos.',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Se você quiser aproveitar o calor carioca, viaje entre novembro e fevereiro. De março à maio,' +
            ' as temperaturas são mais amenas, mas há mais chance de chuvas e dias nublados.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'Se quiser fugir do trânsito, a melhor opção é o transporte público da cidade, que conta com ônibus,' +
            ' micro-ônibus, metrô e trens em um sistema totalmente integrado. Para quem prefere se locomover' +
            ' de táxi ou usando aplicativos, a cidade também oferece muitas opções. Alugar um carro não é' +
            ' uma boa opção para se locomover durante a sua viagem. Porém, dependendo da localização do seu ' +
            'hotel, você poderá fazer muitos passeios a pé.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Rio_Janeiro/rio_desktop04.jpg'
            }
        ]
    },
    {
        id: 2796,
        titulo: 'Salvador',
        slug: 'salvador',
        estado: 'Bahia',
        pais: 'Brasil',
        totalHoteis: 24,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop01.jpg',
        alt: 'Montreal Viagens - Salvador',
        resumo: 'A primeira Capital do Brasil Colônia é repleta de história, tradições, cultura, belezas e uma...',
        descricao: '' +
            'O acervo arquitetônico e paisagístico de Salvador tem cerca de 3 mil edifícios construídos nos' +
            ' séculos XVIII, XIX e XX. Fundada sobre uma falha geográfica de aproximadamente 75 metros,' +
            ' a cidade está dividida em Cidade Alta e Cidade Baixa, que se comunicam pelas extensas ladeiras' +
            ' da região ou pelo Elevador Lacerda – uma obra do engenheiro baiano Antônio de Lacerda, concluída' +
            ' em 1873, que proporciona uma maravilhosa vista da Baía de Todos os Santos. Nomeado Patrimônio' +
            ' Cultural da Humanidade pela UNESCO, o Centro Histórico de Salvador é um dos pontos turísticos' +
            ' mais procurados pelos visitantes. Formado pelo Pelourinho, o Terreiro de Jesus e a Praça da Sé, ' +
            'o local, que hoje fascina a todos por sua efervescência artística, seus casarões e um colorido ' +
            'singular, nasceu como espaço de castigo para os escravos. Com 50km de extensão, a orla de ' +
            'Salvador é uma das maiores do país.  Com águas mornas e piscinas naturais, as praias soteropolitanas' +
            ' são ideais para surf, mergulho e muita diversão. O Porto da Barra é uma das mais conhecidas,' +
            ' possui areias grossas e ondas fracas e está cercada por fortes e diversas igrejas.' +
            ' Reserve um tempo para entrar no Forte de Santa Maria, transformado em Espaço Pierre Verger de' +
            ' Fotografia Baiana, com uma exposição permanente do fotógrafo. Outro ponto bem conhecido da' +
            ' cidade é o Forte de São Diogo, onde você pode explorar o acervo digital do Espaço Carybé das ' +
            'Artes. A região de Stella Maris, com recifes e ondas fortes, é uma das mais agitadas, e suas ' +
            'dunas atraem os adeptos do sandboard. Já Amaralina possui um extenso calçadão para caminhadas' +
            ' e corridas. Os arrecifes do Farol da Barra são ótimos para o mergulho. Aproveite para conhecer ' +
            'o Forte de Santo Antônio da Barra, o Museu Náutico da Bahia e o Morro do Cristo.',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'O período de abril a julho é o mais chuvoso na cidade. Para garantir dias de sol na sua' +
            ' viagem, o ideal é conhecer a cidade durante o verão.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'A cidade conta um sistema de transporte público que conecta diversos pontos de Salvador.' +
            ' Para quem prefere se locomover de táxi ou usando aplicativos, a cidade também oferece' +
            ' muitas opções.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Salvador/salvador_desktop04.jpg'
            }
        ]
    },
    {
        id: 7977,
        titulo: 'Gramado e Canela',
        slug: 'gramado',
        estado: 'Rio Grande do Sul',
        pais: 'Brasil',
        totalHoteis: 28,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop01.jpg',
        alt: 'Montreal Viagens - Gramado',
        resumo: 'Gramado e Canela, famosos destinos do inverno do Sul do país, valem a visita em qualquer época do ano.',
        descricao: '' +
            'As cidades, localizadas na Serra Gaúcha, ficam a cerca de 115 km do aeroporto Salgado Filho,' +
            ' de Porto Alegre, capital do Rio Grande do Sul. Para chegar até Gramado e Canela, é possível alugar' +
            ' um veículo, contratar um transfer ou ir de ônibus rodoviário (cuja linha passa pelo aeroporto).' +
            ' Ao longo de todo o ano, acontecem vários eventos na região, despertando o interesse dos visitantes.' +
            ' Na época de Natal, as cidades são um atrativo à parte, em função do conhecido Natal Luz de Gramado.' +
            ' Já no inverno, as baixas temperaturas convidam à gastronomia típica e a ambientes mais intimistas.' +
            ' Com sorte, é possível até ver neve! Além da gastronomia, compras e atmosfera única, o viajante pode' +
            ' desfrutar de muitos atrativos na região. Natal Luz é o evento mais famoso, que atrai milhares de' +
            ' turistas entre os meses de novembro e janeiro. São realizados shows, desfiles e encenações em' +
            ' locais públicos, além de eventos fechados e pagos, que requerem ingresso. Por isso, vale a pena' +
            ' planejar com antecedência, lembrando que a programação muda a cada ano. As datas e atrações' +
            ' podem ser conferidas no site do evento',

        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Gramado e Canela são destinos muito procurados no inverno, especialmente no mês de julho,' +
            ' quando as temperaturas estão mais baixas. Entre outubro e janeiro a demanda volta a crescer,' +
            ' já que neste período os turistas podem aproveitar o Natal Luz e as decorações natalinas das' +
            ' duas cidades. Embora esteja localizada no Sul e em uma região alta, de serra, no verão as' +
            ' temperaturas podem chegar a mais de 30º. No inverno, a temperatura pode ficar negativa — mas ' +
            'isso não atrapalha em nada os passeios! Além do frio, a neblina e a própria arquitetura conferem' +
            ' às cidades um charme europeu. ',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado__demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'Uma das melhores opções para quem quer aproveitar Gramado e Canela por conta própria é alugar' +
            ' um carro. Caso opte por fazer os passeios a pé, escolha os hoteis no centro das cidades.' +
            ' Outra opção para quem opta por não alugar um carro são os táxis, que circulam pelas duas cidades.' +
            ' Também há uma linha de ônibus que conecta Gramado e Canela, percorrendo uma distância de 7km.' +
            ' Outra opção é a linha de ônibus turística de Gramado, que passa pelos principais pontos da' +
            ' cidade.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop04.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Gramado_Canela/gramado_desktop05.jpg'
            }
        ]
    },
    {
        id: 14379,
        titulo: 'Porto de Galinhas',
        slug: 'porto-de-galinhas',
        estado: 'Recife',
        pais: 'Brasil',
        totalHoteis: 11,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop01.jpg',
        alt: 'Montreal Viagens - Porto de galinhas',
        resumo: 'Porto de Galinhas é uma das primeiras opções de destinos de praia do Brasil. O paraíso pernambucano...',
        descricao: '' +
            'Porto de Galinhas é um distrito de Pernambuco localizado a aproximadamente 60km do Aeroporto' +
            ' Internacional do Recife, e atualmente é um dos locais mais visitados por turistas no Nordeste.' +
            ' Além de ter praias de águas verdes, quentes e calmas, um dos pontos altos de Porto de Galinhas' +
            ' são as piscinas naturais. Para acessar as famosas piscinas naturais da região, pegue as jangadas' +
            ' que partem da Praia da Vila. Em dez minutos, você já estará rodeado de peixes e cavalos-marinhos.' +
            ' Dá para chegar às piscinas a pé também, acompanhado por monitores da Prefeitura. A saída é ' +
            'feita no Posto do Praia Legal, da Prefeitura de Ipojuca, que fica na Praça do Relógio, e dura ' +
            'em média 30 minutos. Quem prefere explorar praias mais vazias, deve aproveitar a região norte.' +
            ' A Praia de Muro Alto é uma das mais famosas da região, onde estão localizados alguns resorts ' +
            'famosos de Porto de Galinhas, como o Nannai e o Summerville. Além de ser mais vazia, a praia ' +
            'tem um cenário paradisíaco, já que é cercada por uma barreira de corais, que formam uma grande ' +
            'piscina natural.Outros destaques deste paraíso nordestino são o artesanato e a culinária locais.' +
            ' Aproveite a Feirinha de Artesanato de Porto de Galinhas para fazer compras e garantir suas ' +
            'lembrancinhas de viagem. No que diz respeito à gastronomia, se delicie com os temperos locais ' +
            'e não se esqueça de provar o famoso bolo de rolo de Pernambuco.',
        recomendacao: [
            {
                categoria: 'Luxo'
            },
            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Quem quer aproveitar a praia sem chuva e ainda apreciar as águas do mar mais claras, ' +
            'deve viajar entre setembro e março. Por ser um dos principais pontos turísticos do nordeste, ' +
            'a cidade praticamente nunca fica vazia. Porém, o período entre dezembro e fevereiro é considerado' +
            ' alta temporada.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'Porto de Galinhas é uma região relativamente pequena. Se você contar com o suporte de um carro' +
            ' na sua viagem, poderá ter mais flexibilidade na hora de traçar as suas rotas. Porém, caminhar ' +
            'é uma ótima opção para os turistas. Optar por transporte público não é a melhor opção para o ' +
            'turista.',
        galeriaDeImagens: [
            {
                // tslint:disable-next-line:max-line-length
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop01.jpg'
            },
            {
                // tslint:disable-next-line:max-line-length
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop02.jpg'
            },
            {
                // tslint:disable-next-line:max-line-length
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop03.jpg'
            },
            {
                // tslint:disable-next-line:max-line-length
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Porto_Galinhas/portodegalinhas_desktop04.jpg'
            }
        ]
    },
    {
        id: 4103,
        titulo: 'João Pessoa',
        slug: 'joao-pessoa',
        estado: 'Paraiba',
        pais: 'Brasil',
        totalHoteis: 30,
        imagem: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop01.jpg',
        alt: 'Montreal Viagens - João Pessoa',
        resumo: '' +
            'O nordeste brasileiro é uma das primeiras escolhas de destino de quem quer aproveitar' +
            ' as férias à beira-mar.',
        descricao: '' +
            'Quem visita João Pessoa, na Paraíba, costuma ficar encantado com a combinação de belas praias,' +
            ' ruas arborizadas, população hospitaleira e um acervo histórico-arquitetônico bem conservado.' +
            ' E não é à toa. Jampa, como é carinhosamente conhecida, é a terceira capital mais antiga do País.' +
            ' As praias urbanas como Tambaú, Manaíra e Cabo Branco, além de limpas, oferecem toda a' +
            ' infraestrutura para os turistas. Se estiver de carro, aproveite para passear pelo litoral sul,' +
            ' na direção de Pernambuco. As paisagens são mais rústicas e apresentam cenários maravilhosos, ' +
            'como Carapibus, Tabatinga, Coqueirinho e Tambaba – o mais famoso endereço naturista do país –, ' +
            'distante apenas 33km da capital. Se o seu negócio é surfar, inverta o destino e vá para o norte,' +
            ' para Barra de Camaratuba, a aproximadamente 110km de João Pessoa. Viajando com as crianças? ' +
            'Inclua no roteiro as piscinas naturais de Picãozinho, repletas de peixes coloridos, localizadas' +
            ' a menos de 2km da costa, na praia de Tambaú. O tour dura cerca de quatro horas. Mas atenção! ' +
            'As piscinas só se formam durante as luas cheia e nova. Em terra, explore a Praia do Seixas, que,' +
            ' além de linda, ostenta a Ponta do Seixas, marco reconhecido como a parte mais oriental das ' +
            'Américas. Ou seja, é aqui que o sol nasce primeiro no Brasil. Por isso, a capital paraibana ' +
            'também é denominada Porta do Sol. Reserve ainda uma parte do dia para o Centro Cultural São Francisco,' +
            ' o mais importante conjunto de arte barroca do estado; o Forte de Santa Catarina do Cabedelo; ' +
            'e a Praça Antenor Navarro, pontilhada de pequenos prédios em estilo art déco. João Pessoa também' +
            ' tem modernidade, como a Estação Cabo Branco – Ciência Cultura e Artes, projetada por Oscar Niemeyer.' +
            ' Para finalizar, não perca o show de Jurandy do Sax, na praia fluvial do Jacaré, que toca o ' +
            'Bolero de Ravel enquanto o sol se põe. O espetáculo acontece há mais de 15 anos, sempre às 16h30.' +
            ' A gastronomia da região também impressiona. Além dos frutos do mar, as receitas do sertão, ' +
            'à base de carne de sol e de bode, arroz de leite, feijão-de-corda, macaxeira e manteiga de garrafa,' +
            ' são deliciosas. Entre as opções de restaurantes, Mangai, Nau, Tasca da Esquina, Bar Buchadas,' +
            ' Tábua de Carne e Quintal Restô – que só atende sob reserva. Com tantas atrações, difícil mesmo' +
            ' é programar o tempo para desfrutar tudo o que a capital paraibana oferece.',
        recomendacao: [

            {
                categoria: 'Praia'
            },
            {
                categoria: 'Relaxar'
            },
            {
                categoria: 'Natureza'
            }
        ],
        clima: [
            {

            }
        ],
        climaDescricao: '' +
            'Os melhor período para quem quer escapar das chuvas são os meses entre setembro e janeiro, ' +
            'que é considerado o período mais seco da região. A partir de dezembro, a água quente do mar ' +
            'ganha incríveis tonalidades de verde e azul.',
        imgDemanda: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa__demanda.jpg',
        demandaDescricao: '* Hotéis em alta temporada podem solicitar taxas extras.',
        transporte: '' +
            'A melhor opção para você aproveitar João Pessoa ao máximo e dar o seu próprio ritmo à viagem é' +
            ' estar de carro. Se alugar um carro ou viajar de carro próprio não são opções para você, escolha' +
            ' bem a localização do seu hotel. Assim, você poderá fazer caminhadas pelo bairro em que estiver' +
            ' hospedado, mas precisará contar com o auxílio de um táxi ou do transporte público local ' +
            '(que apesar de ser uma opção mais barata, não oferece tanta qualidade) para se locomover entre ' +
            'um bairro e outro. Outra opção são os trens urbanos, que circulam na região metropolitana da ' +
            'cidade.',
        galeriaDeImagens: [
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop01.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop02.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop03.jpg'
            },
            {
                url: 'https://www.viagensmontreal.com/design/Destinos_Site_Novo/Joao_Pessoa/joaopessoa_desktop04.jpg'
            }
        ]
    }
];
